export default __webpack_public_path__ + "static/media/user2.3e3e4a7b.svg";